import styled from 'styled-components';
import { LinkWithNativeEvents } from '../../_common/link/link';

export const MultilineText = styled.div<{
  noBottomMargin?: boolean;
}>`
  margin-bottom: ${(props) => (props.noBottomMargin ? '0px' : '10px')};
`;

export const LoadingMessage = styled.p`
  margin: 0;
  padding: 0;
`;

export const ErrorMessage = styled.p`
  margin: 0;
  padding: 0;
`;

export const A = styled(LinkWithNativeEvents)`
  color: var(--cvna-color-blue-2);
  font-weight: 700;
`;

export const Footnote = styled.p`
  font-size: 12px;
  margin: 39px 0 0;
`;

export const SectionItemHeader = styled.h3`
  font-size: 24px;
`;

export const Link = styled(LinkWithNativeEvents)<any>`
  text-decoration: none;
  color: var(--cvna-color-blue-2);

  &:hover {
    text-decoration: none;
    color: var(--cvna-color-blue-3);
    cursor: pointer;
  }

  &:visited {
    text-decoration: none;
    color: var(--cvna-color-blue-3);
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  justify-content: 'space-between';
  gap: 8px;

  button {
    min-width: 100px;
    flex: 1;
  }

  button:last-child {
    width: 100%;
  }
`;
